export default __webpack_public_path__ + "static/media/md5_email.57123231.csv";